import type { ButtonHTMLAttributes } from "react";
import { Icon } from "@mmm/ui";
interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string;
  label: string;
  active?: boolean;
}

export function IconButton({ icon, label, className = "", active = false, ...props }: IconButtonProps) {
  return (
    <button
      type="button"
      className={`mmm-icon-btn ${active ? "is-active" : ""} ${className}`.trim()}
      title={label}
      aria-label={label}
      {...props}
    >
      <Icon name={icon} />
    </button>
  );
}
